import { render, staticRenderFns } from "./TwoFactorModal.vue?vue&type=template&id=19475250&scoped=true"
import script from "./TwoFactorModal.vue?vue&type=script&lang=js"
export * from "./TwoFactorModal.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorModal.vue?vue&type=style&index=0&id=19475250&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19475250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19475250')) {
      api.createRecord('19475250', component.options)
    } else {
      api.reload('19475250', component.options)
    }
    module.hot.accept("./TwoFactorModal.vue?vue&type=template&id=19475250&scoped=true", function () {
      api.rerender('19475250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding/shared/TwoFactorModal.vue"
export default component.exports